var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 214,
    viewBox: "0 0 101 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9334 34.1495C46.2484 55.1912 62.8085 69.1249 62.8085 69.1249C62.8085 69.1249 83.0535 62.017 86.7385 40.9754C90.4235 19.9337 73.8634 6 73.8634 6C73.8634 6 53.6184 13.108 49.9334 34.1495Z",
    stroke: "#E3DBEB",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5486 127.057C36.5277 141.312 57.2988 133.375 57.2988 133.375C57.2988 133.375 61.0909 111.183 44.1118 96.9284C27.1326 82.6736 6.36147 90.6109 6.36147 90.6109C6.36147 90.6109 2.56956 112.802 19.5486 127.057Z",
    stroke: "#E3DBEB",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4896 205.806C91.4271 198.539 94.3749 178.162 94.3749 178.162C94.3749 178.162 78.3852 165.052 59.4478 172.319C40.5103 179.586 37.5625 199.963 37.5625 199.963C37.5625 199.963 53.5522 213.073 72.4896 205.806Z",
    stroke: "#E3DBEB",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3755 178.162C76.636 163.002 56.4937 132.962 56.4937 103.557C56.4937 91.3803 58.449 79.7579 61.9999 69.125",
    stroke: "#E3DBEB",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftFlower);
export default __webpack_public_path__ + "static/media/leftFlower.9587d806470d32714c4b05dedad840bc.svg";
export { ForwardRef as ReactComponent };